<template>
  <div class="add-pay-box">
    <el-dialog title="楼凤详情页" :visible.sync="dialogVisible" width="90%" :before-close="handleClose" :close-on-click-modal="false">
    <el-table :data="tableData" style="width: 100%" border  ref="multipleTable" >
      <el-table-column prop="title" label="标题" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cover" label="封面" align="center" width="200">
        <template slot-scope="scope">
          <span v-if="!scope.row.cover || !scope.row.cover.length">未知</span>
          <div
            v-else
            class="picturePreview"
            @click="previewPicture(scope.row.cover, scope.row.id)"
          >
            <el-image
              style="width: 50px; height: 50px"
              :src="imgUrl + item"
              fit="fill"
              v-for="(item,i) in scope.row.cover"
              :key="i"
            ></el-image>
          </div>
        </template>
      </el-table-column>     
      <el-table-column prop="city" label="城市" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.city || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="district" label="区,县" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.district}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{(scope.row.age|| '未知') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系方式" align="center" min-width="260">
        <template slot-scope="scope">
          <span>{{scope.row.contact }}</span>
        </template>
      </el-table-column>
     </el-table>
    </el-dialog>
        <!-- 背景图集预览窗口 -->
    <preview-picture ref="previewPicture" @handlerChannelList="getLouFengList"></preview-picture>
  </div>
</template>
<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'
import PreviewPicture from '../components/previewPicture'
export default {
  data() {
    return {
      //图集上传
      action: baseConfig.baseServerUrl + '/vid/uploadStaticBatch',
      imgUrl: baseConfig.imgUrl,
      dialogVisible: false,
      tableData:[],
      lf_param:{
        pageNumber: 1,
        pageSize: 10,
      },
      param:{
        pageNumber: 1,
        pageSize: 10,
      }
    }
  },
  components: {
    PreviewPicture,
  },
  methods: {
    // 关闭弹窗
    handleClose() {
       this.dialogVisible = false
       this.$emit("handlerChannelList");
    },
    //  图集预览
    previewPicture(pictureArr, id) {
      const Arr = JSON.parse(JSON.stringify(pictureArr))
      this.$refs.previewPicture.open(Arr, id)
    },    
        // 请求楼凤信息列表
    getLouFengList(id) {
       let lf_param=Object.assign({},this.lf_param,{id:id})
      API.queryFeedback(lf_param)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.data
          } else {
            this.tableData = []
          }
        })
        .catch(() => {
        })
    },    
    // 打开编辑视频弹窗、传递需要编辑的参k
    open( data) {
      this.dialogVisible = true
      this.id=data.loufengID
      this.getLouFengList(this.id)
    },
  },
}
</script>

<style lang="scss"  scoped>
.add-pay-box {
  .el-date-picker,
  .el-input {
    width: 150px;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>

<style lang="scss">
.add-pay-box .el-upload {
  width: 20%;
}
</style>